import type { CSSProperties } from "react";
import { cx } from "../../lib/cx";

export function Skeleton({ className, style }: { className?: string; style?: CSSProperties }) {
  return <div className={cx("skeleton", className)} style={style} aria-hidden="true" />;
}

export function SkeletonList({ count = 3, rowClassName }: { count?: number; rowClassName?: string }) {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className={cx("skeleton-row", rowClassName)} />
      ))}
    </div>
  );
}
